
<script>
export default {
  name: 'search-form-menu'
}
</script>

<template>
  <div class="search-form__menu">
    <router-link
      :to="{ name: 'ToursSearch' }"
      class="search-form__menu-item"
    >
      Туры
    </router-link>
    <router-link
      :to="{ name: 'HotelsSearch' }"
      class="search-form__menu-item"
    >
      Отели
    </router-link>
    <router-link
      :to="{ name: 'FitRequest' }"
      class="search-form__menu-item"
    >
      FIT
    </router-link>
  </div>
</template>
